<template>

</template>

<script>
	import Errors from "../../../Utils/Errors";

	export default {
		data() {
			return {
				providerList: {},
				userRoles: this.$currentUserRoles,
				languages: this.$availableLanguages,
				selectedLanguage: 0,
				selectedLanguageSlug: '',

				affiliateTag: '',
				sharing: {},

				partnerModalVisible: false,
				actualPartner: {},
				newPartner: false,
				urlCheck: false,
				modalMessage: '',

				errors: new Errors(),
			}
		},
		created() {
			this.loadProviderList();
		},
		computed: {
			orderedSharings: function () {
				return _.orderBy(this.sharing.partners, ['name'], ['asc'])
			},
		},
		methods: {

			loadProviderList: function () {
				let vm = this;

				axios.post('/api/' + vm.$selectedSite.slug + '/providerlists/getlist')
					.then(response => {
						vm.providerList = response.data.providerList;
						vm.sharing = response.data.sharing;
						vm.affiliateTag = '';
						if (typeof vm.sharing === 'object' && vm.sharing.hasOwnProperty('affiliate_tag')) {
							vm.affiliateTag = response.data.sharing.affiliate_tag;
						}
						this.setLanguage(0);
					});
			},


		}
	}
</script>

